import { Chapters } from 'backend/services/types/urApiService.types'

/**
 *
 * @param url URL to get from
 * @param timeout Timeout in milliseconds
 */
export const fetchWithTimeout = <T>(
  url: string,
  timeout: number,
): Promise<T> => {
  const controller = new AbortController()
  const { signal } = controller
  setTimeout(() => controller.abort(), timeout)

  return fetch(url, { signal }).then(response => response.json())
}

const buildThumbnailTrack = (urAssetsId: number) => {
  return {
    file: `https://assets.ur.se/id/${urAssetsId}/images/thumbnails.vtt`,
    kind: 'thumbnails',
  }
}

const buildChaptersTrack = (chapter: Chapters) => {
  return {
    file: chapter.location,
    kind: 'chapters',
  }
}

export const buildTracks = (
  urAssetId: number,
  format: string,
  chapters?: Chapters | null,
  includeChapters?: boolean,
): { file: string; label?: string; kind?: string }[] => {
  return format !== 'audio'
    ? [
        buildThumbnailTrack(urAssetId),
        ...(chapters && includeChapters ? [buildChaptersTrack(chapters)] : []),
      ]
    : [...(chapters && includeChapters ? [buildChaptersTrack(chapters)] : [])]
}

export const getRandomId = () =>
  (Date.now() + Math.random() * 1000000).toString(36).substring(0, 8)

export const toIntegerMilliseconds = (seconds: number) => {
  return Math.round(seconds * 1000)
}

export const PLAYER_CHAPTER_BUTTON_ID = 'player-chapter-button'
export const toggleChapterButtonAttributes = () => {
  const buttonContainer = document.querySelector(
    `div[button="${PLAYER_CHAPTER_BUTTON_ID}"]`,
  )
  buttonContainer?.classList.toggle('active')
  const isExpanded = buttonContainer?.getAttribute('aria-expanded') === 'true'

  if (isExpanded) {
    buttonContainer?.setAttribute('aria-expanded', 'false')
    buttonContainer?.setAttribute('aria-label', 'Visa kapitel')
  } else {
    buttonContainer?.setAttribute('aria-expanded', 'true')
    buttonContainer?.setAttribute('aria-label', 'Dölj kapitel')
  }
}
